module.exports = "data:image/svg+xml;base64,PHN2ZyB0PSIxNjE2NTUxODc4NDA5IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjEyNTI0IiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiPjxwYXRoIGQ9Ik04NzIgNzI4YTcyIDcyIDAgMCAxIDAgMTQ0SDE1MmE3MiA3MiAwIDAgMSAwLTE0NGg3MjB6IG0wLTI4OGE3MiA3MiAwIDAgMSAwIDE0NEgxNTJhNzIgNzIgMCAwIDEgMC0xNDRoNzIweiBtMC0yODhhNzIgNzIgMCAwIDEgMCAxNDRIMTUyYTcyIDcyIDAgMCAxIDAtMTQ0aDcyMHoiIHAtaWQ9IjEyNTI1Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/list.svg
// module id = vuHp
// module chunks = 10